import { Query } from '@datorama/akita';
import { AuthenticationState, AuthenticationStore } from './authentication.store';
import { Injectable } from '@angular/core';
import { AuthenticationToken, UserRoles } from '../constants/authentication.constants';
import { TokenInfo } from '../interfaces/token-info.interface';
import { Router } from '@angular/router';
import { SharedUrls } from '../../shared/constants/shared.constants';
import { jwtDecode } from 'jwt-decode';

@Injectable({ providedIn: 'root' })
export class AuthenticationQuery extends Query<AuthenticationState> {

  constructor(protected override store: AuthenticationStore, private router: Router) {
    super(store);
  }

  get authenticationState() {
    return this.getValue();
  }

  get tokenInfo() {
    return JSON.parse(localStorage.getItem(AuthenticationToken.TokenInfo) ?? '{}');
  }

  get userInfo() {
    return this.authenticationState.userInfo;
  }

  get isUserLoggedIn() {
    return this.tokenInfo !== null;
  }

  get givenName() {
    return this.userInfo ? this.userInfo.given_name : null;
  }

  get roles() {
    return localStorage.getItem(UserRoles.Roles) ? JSON.parse(localStorage.getItem(UserRoles.Roles) ?? '') : '';
  }

  get isMfaVerified(): boolean {
    return this.authenticationState.mfaVerified === true;
  }

  logout() {
    localStorage.removeItem(AuthenticationToken.TokenInfo);
    this.store.update({ mfaVerified: false });
    this.router.navigate([SharedUrls.Login]);
  }

  getTokenExpirationDate(token: string): Date | null {
    const decoded = jwtDecode(token);
    if (decoded['exp'] === undefined) {
      return null;
    }
    const date = new Date(0);
    date.setUTCSeconds(decoded['exp']);
    return date;
  }


  get tokenExpired() {
    return this.isTokenExpired(this.tokenInfo.access_token);
  }

  isTokenExpired(token?: string): boolean {
    if (!token) { return true; }

    const date = this.getTokenExpirationDate(token);
    if (!date) { return false; }
    return !(date.valueOf() > new Date().valueOf());
  }
}
